import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

const Contact = () => {
  const [state, handleSubmit] = useForm("xblkybwd");

  return (
    <div style={{
      minHeight: '100vh',
      background: '#a8a8a8',
      fontFamily: "'Cormorant Garamond', serif",
      padding: '20px'
    }}>
      <main style={{
        maxWidth: '750px',
        margin: '50px auto',
        padding: '30px',
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        backdropFilter: 'blur(5px)',
        color: 'black',
        fontSize: '20px'
      }}>
        <h2 style={{ 
          fontSize: '32px', 
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>Contact Us</h2>
        
        <div style={{ marginBottom: '30px' }}>
          <p><strong>Registered office address:</strong> 44 Coombe Lane, London, SW20 0LA</p>
          <div>
            <p><strong>Email:</strong> <a href="mailto:info@southernhomemove.co.uk" style={{ 
              color: 'black', 
              textDecoration: 'none' 
            }}>info@southernhomemove.co.uk</a></p>
          </div>
        </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '15px',
          padding: '30px',
          marginTop: '30px',
          textAlign: 'left'
        }}>
          <h3 style={{ 
            textAlign: 'center', 
            marginBottom: '25px',
            fontSize: '24px',
            fontWeight: 'bold'
          }}>Send us an Enquiry</h3>
          
          {state.succeeded && (
            <div style={{
              background: '#d4edda',
              color: '#155724',
              padding: '20px',
              borderRadius: '10px',
              marginBottom: '20px',
              textAlign: 'center',
              border: '1px solid #c3e6cb',
              fontSize: '18px'
            }}>
              <strong>Thank you!</strong> Your message has been sent successfully. We'll get back to you soon.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="name" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
                fontSize: '18px'
              }}>
                Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid rgba(0, 0, 0, 0.2)',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontFamily: "'Cormorant Garamond', serif",
                  background: 'rgba(255, 255, 255, 0.8)',
                  boxSizing: 'border-box'
                }}
                placeholder="Your full name"
              />
              <ValidationError 
                prefix="Name" 
                field="name"
                errors={state.errors}
                style={{ color: '#721c24', fontSize: '14px', marginTop: '5px' }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="email" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
                fontSize: '18px'
              }}>
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid rgba(0, 0, 0, 0.2)',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontFamily: "'Cormorant Garamond', serif",
                  background: 'rgba(255, 255, 255, 0.8)',
                  boxSizing: 'border-box'
                }}
                placeholder="your.email@example.com"
              />
              <ValidationError 
                prefix="Email" 
                field="email"
                errors={state.errors}
                style={{ color: '#721c24', fontSize: '14px', marginTop: '5px' }}
              />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label htmlFor="message" style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
                fontSize: '18px'
              }}>
                Your Enquiry *
              </label>
              <textarea
                id="message"
                name="message"
                required
                rows={6}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid rgba(0, 0, 0, 0.2)',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontFamily: "'Cormorant Garamond', serif",
                  background: 'rgba(255, 255, 255, 0.8)',
                  resize: 'vertical',
                  minHeight: '120px',
                  boxSizing: 'border-box'
                }}
                placeholder="Please tell us about your enquiry..."
              />
              <ValidationError 
                prefix="Message" 
                field="message"
                errors={state.errors}
                style={{ color: '#721c24', fontSize: '14px', marginTop: '5px' }}
              />
            </div>

            <div style={{ textAlign: 'center' }}>
              <button
                type="submit"
                disabled={state.submitting}
                style={{
                  background: state.submitting ? '#999' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  padding: '15px 40px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  borderRadius: '25px',
                  cursor: state.submitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  fontFamily: "'Cormorant Garamond', serif",
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                  transform: state.submitting ? 'none' : 'translateY(0)',
                }}
                onMouseEnter={(e) => {
                  if (!state.submitting) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!state.submitting) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                  }
                }}
              >
                {state.submitting ? 'Sending...' : 'Send Enquiry'}
              </button>
            </div>
          </form>

          <p style={{
            textAlign: 'center',
            marginTop: '20px',
            fontSize: '14px',
            color: '#666',
            fontStyle: 'italic'
          }}>
            * Required fields
          </p>
        </div>
      </main>
    </div>
  );
};

export default Contact;